var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99954 18C9.69846 17.9996 9.40447 17.9086 9.15579 17.7389C5.47189 15.2381 3.87673 13.5234 2.99689 12.4514C1.12189 10.1663 0.224231 7.82016 0.249544 5.27953C0.279075 2.36813 2.61486 0 5.45642 0C7.52267 0 8.95376 1.16391 9.7872 2.13328C9.8136 2.16368 9.84622 2.18805 9.88286 2.20476C9.91949 2.22146 9.95928 2.23011 9.99954 2.23011C10.0398 2.23011 10.0796 2.22146 10.1162 2.20476C10.1529 2.18805 10.1855 2.16368 10.2119 2.13328C11.0453 1.16297 12.4764 0 14.5427 0C17.3842 0 19.72 2.36812 19.7495 5.28C19.7749 7.82109 18.8763 10.1672 17.0022 12.4519C16.1224 13.5239 14.5272 15.2386 10.8433 17.7394C10.5946 17.9089 10.3006 17.9998 9.99954 18Z",
    fill: "#FF9A6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like_icon.58c6851a57db2fcd10e11bacabefa457.svg";
export { ForwardRef as ReactComponent };